import { CanonicalPeriod, EmissionTier, MetricState, PERIODS } from '../common'
import { parseMetricPointY, sumMetricNode, sumNumbers } from '../common/financialMetrics'

type MetricResultLike<T = unknown> =
  | {
      state?: { value?: MetricState }
      data?: T | null
    }
  | undefined

function isRecord(value: unknown): value is Record<string, unknown> {
  return value != null && typeof value === 'object' && !Array.isArray(value)
}

export function getSucceededMetricData<T = unknown>(metric: MetricResultLike<T>): T | null {
  if (!metric || metric.state?.value !== MetricState.SUCCEEDED) return null
  return metric.data ?? null
}

export function getRecordValue(value: unknown, key: string): unknown {
  return isRecord(value) ? value[key] : undefined
}

export function getRecordKeys(value: unknown): string[] {
  return isRecord(value) ? Object.keys(value) : []
}

export function getMetricKeys(payload: unknown, key: string): string[] {
  const keys = getRecordValue(getRecordValue(payload, 'keys'), key)
  return Array.isArray(keys) ? keys.filter((item): item is string => typeof item === 'string' && item.length > 0) : []
}

export function getPeriodNode(payload: unknown, emissionTier: EmissionTier | string, period: CanonicalPeriod): unknown {
  return getRecordValue(getRecordValue(getRecordValue(payload, 'data'), emissionTier), period)
}

export function getSelectedPeriodPointY(
  payload: unknown,
  emissionTier: EmissionTier | string,
  period: CanonicalPeriod,
): number | null {
  return parseMetricPointY(getPeriodNode(payload, emissionTier, period))
}

export function sumSelectedPeriodNode(
  payload: unknown,
  emissionTier: EmissionTier | string,
  period: CanonicalPeriod,
): number | null {
  return sumMetricNode(getPeriodNode(payload, emissionTier, period))
}

export function hasAnyCanonicalPeriodData(readers: Array<(period: CanonicalPeriod) => number | null>): boolean {
  return PERIODS.some(period => readers.some(read => read(period) != null))
}

export function getTotalAalValue(
  damageAal: number | null | undefined,
  revenueAal: number | null | undefined,
): number | null {
  return sumNumbers([damageAal, revenueAal])
}
